export default __webpack_public_path__ + "static/media/air-sub-meter-icon.c852f742.svg";